<template>
  <div class="gx-topbar">
    <button class="gx-topbar__logo" @click="$emit('logo')">
      <img class="gx-topbar__logo-icon" src="https://xinghaohuo.oss-cn-beijing.aliyuncs.com/logo.png" alt="观星树 Logo">
      <span class="gx-topbar__logo-text">
        <span class="gx-topbar__logo-name">观星树</span>
        <span class="gx-topbar__logo-sub">AI智能店群运营</span>
      </span>
    </button>

    <span class="gx-topbar__divider"></span>

    <nav class="gx-topbar__nav" v-if="visibleNavItems&&visibleNavItems.length">
      <button
        v-for="item in visibleNavItems"
        :key="item.label"
        class="gx-topbar__nav-item"
        :class="{ 'gx-topbar__nav-item--active': item.active }"
        @click="$emit('nav', item.id)"
      >
        {{ item.label }}
      </button>
    </nav>
    <div class="gx-topbar__center" v-else>
      <slot name="center"></slot>
    </div>

    <div class="gx-topbar__right">
      <button class="gx-topbar__legacy" title="访问旧系统" @click="$emit('legacy')">
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
          <path d="M2 8h11M9 4l4 4-4 4" stroke="#fff" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span>访问旧系统</span>
      </button>

      <div class="gx-topbar__bell-wrap" v-if="showNotification">
        <button class="gx-topbar__bell" title="通知" @click.stop="toggleNotif">
          <svg width="16" height="16" viewBox="0 0 18 18" fill="none">
            <path d="M9 2a6 6 0 016 6v3l1.5 2H1.5L3 11V8a6 6 0 016-6z" stroke="#fff" stroke-width="1.4" />
            <path d="M7 15a2 2 0 004 0" stroke="#fff" stroke-width="1.4" />
          </svg>
          <span v-if="unread > 0" class="gx-topbar__badge">{{ unread }}</span>
        </button>

        <!-- 通知下拉面板 -->
        <div v-if="notifOpen" class="gx-topbar__notif" @click.stop>
          <div class="gx-topbar__notif-head">
            <div class="gx-topbar__notif-title-row">
              <div class="gx-topbar__notif-title-wrap">
                <span class="gx-topbar__notif-title">通知</span>
                <span v-if="unread > 0" class="gx-topbar__notif-badge">{{ unread }}</span>
              </div>
              <div class="gx-topbar__notif-head-actions">
                <button v-if="unread > 0" class="gx-topbar__notif-link" @click="markAllRead">全部已读</button>
                <button class="gx-topbar__notif-close" @click="notifOpen = false">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1 1l8 8M9 1L1 9" stroke="#8A95B0" stroke-width="1.4" stroke-linecap="round" /></svg>
                </button>
              </div>
            </div>
            <div class="gx-topbar__notif-tabs">
              <button
                v-for="t in notifTabs"
                :key="t.id"
                class="gx-topbar__notif-tab"
                :class="{ 'gx-topbar__notif-tab--on': notifTab === t.id }"
                @click="notifTab = t.id"
              >
                {{ t.label }}
                <span v-if="t.count > 0" class="gx-topbar__notif-tab-dot"></span>
                <span v-if="notifTab === t.id" class="gx-topbar__notif-tab-beam"></span>
              </button>
            </div>
          </div>

          <div class="gx-topbar__notif-list">
            <div v-if="!visibleNotifs.length" class="gx-topbar__notif-empty">
              <div class="gx-topbar__notif-empty-icon">🔔</div>
              <div class="gx-topbar__notif-empty-text">暂无通知</div>
            </div>
            <div
              v-for="(n, i) in visibleNotifs"
              :key="n.id"
              class="gx-topbar__notif-item"
              :class="{ 'gx-topbar__notif-item--unread': !n.isRead }"
              :style="{ borderBottom: i < visibleNotifs.length - 1 ? '1px solid rgba(212,169,70,.08)' : 'none' }"
            >
              <span v-if="!n.isRead" class="gx-topbar__notif-dot"></span>
              <div class="gx-topbar__notif-item-row">
                <span class="gx-topbar__notif-tag" :style="tabStyle(n.type)">{{ tabLabel(n.type) }}</span>
                <span class="gx-topbar__notif-item-title" :class="{ 'gx-topbar__notif-item-title--read': n.isRead }">{{ n.title || '新消息' }}</span>
                <span class="gx-topbar__notif-item-time">{{ notifTime(n.created_at) }}</span>
              </div>
              <div class="gx-topbar__notif-source">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><circle cx="5" cy="5" r="4" stroke="rgba(212,169,70,.4)" stroke-width="1" /><path d="M5 3v2.5L7 7" stroke="rgba(212,169,70,.4)" stroke-width="1" stroke-linecap="round" /></svg>
                <span>{{ n.source || '系统消息' }}</span>
              </div>
              <p class="gx-topbar__notif-content" :class="{ 'gx-topbar__notif-content--read': n.isRead }">{{ n.content || n.message || '' }}</p>
              <div class="gx-topbar__notif-actions">
                <button v-if="!n.isRead" class="gx-topbar__notif-mini" @click="markRead(n)">标为已读</button>
              </div>
            </div>
          </div>

          <div class="gx-topbar__notif-foot">
            <button class="gx-topbar__notif-link" @click="goAll">查看全部消息 →</button>
          </div>
        </div>
      </div>

      <!-- 全部消息弹窗 -->
      <div v-if="allOpen" class="gx-topbar__all" @click.self="allOpen = false">
        <div class="gx-topbar__all-box">
          <div class="gx-topbar__all-head">
            <div class="gx-topbar__all-title-wrap">
              <span class="gx-topbar__all-title">全部消息</span>
              <span v-if="unread > 0" class="gx-topbar__notif-badge">{{ unread }}</span>
            </div>
            <div class="gx-topbar__all-actions">
              <button v-if="unread > 0" class="gx-topbar__notif-link" @click="markAllRead">全部已读</button>
              <button class="gx-topbar__notif-close" @click="allOpen = false">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1 1l8 8M9 1L1 9" stroke="#8A95B0" stroke-width="1.4" stroke-linecap="round" /></svg>
              </button>
            </div>
          </div>
          <div class="gx-topbar__all-tabs">
            <button
              v-for="t in notifTabs"
              :key="t.id"
              class="gx-topbar__notif-tab"
              :class="{ 'gx-topbar__notif-tab--on': allTab === t.id }"
              @click="allTab = t.id"
            >
              {{ t.label }}
              <span v-if="t.count > 0" class="gx-topbar__notif-tab-dot"></span>
              <span v-if="allTab === t.id" class="gx-topbar__notif-tab-beam"></span>
            </button>
          </div>
          <div class="gx-topbar__all-list">
            <div v-if="!allVisible.length" class="gx-topbar__notif-empty">
              <div class="gx-topbar__notif-empty-icon">🔔</div>
              <div class="gx-topbar__notif-empty-text">暂无通知</div>
            </div>
            <div
              v-for="(n, i) in allVisible"
              :key="n.id"
              class="gx-topbar__notif-item"
              :class="{ 'gx-topbar__notif-item--unread': !n.isRead }"
              :style="{ borderBottom: i < allVisible.length - 1 ? '1px solid rgba(212,169,70,.08)' : 'none' }"
            >
              <span v-if="!n.isRead" class="gx-topbar__notif-dot"></span>
              <div class="gx-topbar__notif-item-row">
                <span class="gx-topbar__notif-tag" :style="tabStyle(n.type)">{{ tabLabel(n.type) }}</span>
                <span class="gx-topbar__notif-item-title" :class="{ 'gx-topbar__notif-item-title--read': n.isRead }">{{ n.title || '新消息' }}</span>
                <span class="gx-topbar__notif-item-time">{{ notifTime(n.created_at) }}</span>
              </div>
              <div class="gx-topbar__notif-source">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><circle cx="5" cy="5" r="4" stroke="rgba(212,169,70,.4)" stroke-width="1" /><path d="M5 3v2.5L7 7" stroke="rgba(212,169,70,.4)" stroke-width="1" stroke-linecap="round" /></svg>
                <span>{{ n.source || '系统消息' }}</span>
              </div>
              <p class="gx-topbar__notif-content" :class="{ 'gx-topbar__notif-content--read': n.isRead }">{{ n.content || n.message || '' }}</p>
              <div class="gx-topbar__notif-actions">
                <button v-if="!n.isRead" class="gx-topbar__notif-mini" @click="markRead(n)">标为已读</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="gx-topbar__user" @click="$emit('user')">
        <span class="gx-topbar__avatar">
          <img v-if="userinfo.avatar && userinfo.avatar !== 'http://'" :src="userinfo.avatar" alt="" />
          <template v-else>{{ avatarText }}</template>
        </span>
        <span class="gx-topbar__user-text">
          <span class="gx-topbar__user-phone">{{ userinfo.nickname || userinfo.name || userinfo.mobile || '未登录' }}</span>
          <span class="gx-topbar__user-level">{{ levelText }}</span>
        </span>
      </div>

      <button v-if="$listeners.logout" class="gx-topbar__logout" @click="$emit('logout')">退出</button>
    </div>
    <!-- 快速上下 -->
    <div class="fixed_menu">
<!--      <el-backtop :bottom="100" class="backtop" :visibility-height="500">
        <i class="iconfont icon-top"></i>
      </el-backtop>-->
      <div v-show="scrollTop>100"  @click="scrollToTop">
        <!-- 垂直上下排列 -->
        <div class="inner-wrap el-backtop backtop">
          <i class="iconfont icon-top"></i>
        </div>
      </div>
      <div v-show="scrollBottom > 200 && scrollTop > 100"  @click="scrollToBottom">
        <!-- 垂直上下排列 -->
        <div class="inner-wrap el-backtop backtop to-bottom">
          <span>BOT</span>
          <i class="iconfont el-icon-arrow-down"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAllowedWorkbenches } from '../../config/newUiPermissions'

export default {
  name: 'TopBanner',
  props: {
    navItems: { type: Array, default: () => [] },
    unread: { type: Number, default: 0 },
    showNotification: { type: Boolean, default: true }
  },
  data() {
    return {
      notifOpen: false,
      allOpen: false,
      allTab: 'all',
      notifTab: 'all',
      scrollTop: 0,
      scrollBottom: 0,
    }
  },
  computed: {
    visibleNavItems() {
      const login = this.$store.state.login
      const userinfo = login.userinfo || {}
      const allowed = new Set(getAllowedWorkbenches(userinfo.new_ui_access, login.is_host).map((item) => item.id))
      return this.navItems.filter((item) => item.id === null || allowed.has(item.id))
    },
    userinfo() {
      return this.$store.state.login.userinfo || {}
    },
    levelText() {
      const level = this.$store.state.login.user_level
      if (level === 1) return '企业版会员'
      // if (level === 2) return '企业版会员'
      return '普通会员'
    },
    avatarText() {
      const name = this.userinfo.nickname || this.userinfo.name || ''
      return name ? name[0] : '星'
    },
    notifs() {
      return this.$store.state.notification.notifications || []
    },
    notifTabs() {
      return [
        { id: 'all', label: '全部', count: this.notifs.filter((n) => !n.isRead).length },
        { id: 'system', label: '系统', count: this.notifs.filter((n) => n.type === 'system' && !n.isRead).length },
        { id: 'import', label: '导入', count: this.notifs.filter((n) => n.type === 'import_progress' && !n.isRead).length },
        { id: 'task', label: '任务', count: this.notifs.filter((n) => n.type === 'task' && !n.isRead).length }
      ]
    },
    visibleNotifs() {
      if (this.notifTab === 'all') return this.notifs
      const map = { system: 'system', import: 'import_progress', task: 'task' }
      return this.notifs.filter((n) => n.type === map[this.notifTab])
    },
    allVisible() {
      if (this.allTab === 'all') return this.notifs
      const map = { system: 'system', import: 'import_progress', task: 'task' }
      return this.notifs.filter((n) => n.type === map[this.allTab])
    }
  },
  mounted() {
    document.addEventListener('click', this.onDocClick)
    const div = document.getElementById('gx-main');
    if(div) div.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocClick)
    const div = document.getElementById('gx-main');
    if(div) div.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onDocClick() {
      this.notifOpen = false
    },
    toggleNotif() {
      this.notifOpen = !this.notifOpen
    },
    tabLabel(type) {
      const map = { import_progress: '导入', system: '系统', task: '任务' }
      return map[type] || '消息'
    },
    tabStyle(type) {
      const map = {
        system: { color: '#D4A946', background: '#E1E5EE' },
        import: { color: '#00D4FF', background: 'rgba(0,212,255,.12)' },
        task: { color: '#52C41A', background: 'rgba(82,196,26,.12)' }
      }
      const s = map[type] || { color: '#D4A946', background: '#E1E5EE' }
      return { color: s.color, background: s.background }
    },
    notifTime(ts) {
      if (!ts) return ''
      let time
      if (typeof ts === 'number') {
        time = new Date(ts < 10000000000 ? ts * 1000 : ts)
      } else {
        time = new Date(ts)
      }
      if (isNaN(time.getTime()) || time.getFullYear() < 2000) return ''
      const now = new Date()
      const diff = now - time
      if (diff < 0) return '刚刚'
      if (diff < 60 * 1000) return '刚刚'
      if (diff < 60 * 60 * 1000) return Math.floor(diff / (60 * 1000)) + '分钟前'
      if (diff < 24 * 60 * 60 * 1000) return Math.floor(diff / (60 * 60 * 1000)) + '小时前'
      if (diff < 7 * 24 * 60 * 60 * 1000) return Math.floor(diff / (24 * 60 * 60 * 1000)) + '天前'
      const pad = (x) => String(x).padStart(2, '0')
      const month = pad(time.getMonth() + 1)
      const day = pad(time.getDate())
      const hour = pad(time.getHours())
      const minute = pad(time.getMinutes())
      if (time.getFullYear() === now.getFullYear()) {
        return `${month}-${day} ${hour}:${minute}`
      }
      return `${time.getFullYear()}-${month}-${day} ${hour}:${minute}`
    },
    markRead(n) {
      this.$store.commit('notification/MARK_ONE_AS_READ', n)
    },
    markAllRead() {
      this.$store.commit('notification/MARK_ALL_AS_READ')
    },
    deleteNotif(n) {
      this.$store.commit('notification/DELETE_NOTIFICATION', n)
    },
    goAll() {
      this.notifOpen = false
      this.allTab = 'all'
      this.allOpen = true
    },
    onScroll() {
      // const dom = document.documentElement || document.body;
      const dom = document.getElementById('gx-main');
      // 当前滚动高度（距离顶部）
      this.scrollTop = dom.scrollTop
      // 可视区域高度
      const clientH = dom.clientHeight
      // 页面完整总高度
      const scrollH = dom.scrollHeight
      // 距离底部剩余距离 = 总高度 - 当前滚动高度 - 可视高度
      this.scrollBottom = scrollH - this.scrollTop - clientH

    },
    scrollToTop() {
      // const dom = document.documentElement || document.body;
      const dom = document.getElementById('gx-main');
      dom.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    scrollToBottom() {
      // const dom = document.documentElement || document.body;
      const dom = document.getElementById('gx-main');
      dom.scrollTo({
        top: dom.scrollHeight,
        behavior: "smooth",
      });
    },
  }
}
</script>

<style scoped>
.gx-topbar {
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 100;
  height: 56px;
  background: linear-gradient(135deg, #C8443C 0%, #E05858 100%);
  box-shadow: 0 2px 14px rgba(200, 60, 60, .4);
  border-bottom: 1px solid rgba(240, 100, 100, .18);
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.gx-topbar__logo {
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
}
.gx-topbar__logo-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: block;
  object-fit: contain;
  box-shadow: 0 0 12px rgba(212, 169, 70, .4);
}
.gx-topbar__logo-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: flex-start; */
}
.gx-topbar__logo-name {
  font-family: 'Noto Serif SC', serif;
  font-size: 16px;
  font-weight: 700;
  color: #FFFFFF;
  line-height: 1;
  margin-bottom: 2px;
}
.gx-topbar__logo-sub {
  font-size: 9px;
  color: rgba(255, 255, 255, .7);
  line-height: 1;
  margin-top: 1px;
}
.gx-topbar__divider {
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, .2);
  margin: 0 4px 0 14px;
  flex-shrink: 0;
}
.gx-topbar__nav {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;
  overflow-x: auto;
  scrollbar-width: none;
}
.gx-topbar__nav::-webkit-scrollbar {
  display: none;
}
.gx-topbar__nav-item {
  height: 56px;
  padding: 0 11px;
  border: none;
  cursor: pointer;
  background: transparent;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 12px;
  color: rgba(255, 255, 255, .85);
  border-bottom: 3px solid transparent;
  transition: all .3s cubic-bezier(.4, 0, .2, 1);
  white-space: nowrap;
  flex-shrink: 0;
}
.gx-topbar__nav-item:hover {
  color: #fff;
  background: rgba(255, 255, 255, .12);
}
.gx-topbar__nav-item--active {
  background: rgba(212, 169, 70, .28);
  color: #FFD700;
  font-weight: 700;
  border-bottom-color: #FFD700;
}
.gx-topbar__center{
  flex: 1;
}
.gx-topbar__right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.gx-topbar__legacy {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 30px;
  padding: 0 10px;
  border-radius: 7px;
  border: 1px solid rgba(255, 255, 255, .22);
  background: rgba(255, 255, 255, .15);
  cursor: pointer;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 12px;
  color: rgba(255, 255, 255, .85);
  transition: all .3s cubic-bezier(.4, 0, .2, 1);
  white-space: nowrap;
}
.gx-topbar__legacy:hover {
  background: rgba(212, 169, 70, .22);
  border-color: rgba(212, 169, 70, .5);
  color: #FFD700;
}
.gx-topbar__bell {
  width: 36px;
  height: 36px;
  border-radius: 9px;
  background: rgba(255, 255, 255, .15);
  border: 1px solid rgba(255, 255, 255, .22);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all .3s cubic-bezier(.4, 0, .2, 1);
}
.gx-topbar__bell-wrap {
  position: relative;
}
.gx-topbar__notif {
  position: absolute;
  top: 44px;
  right: -8px;
  z-index: 300;
  width: 380px;
  max-height: 80vh;
  border-radius: 12px;
  background: #FFFFFF;
  border: 1px solid rgba(240, 100, 100, .2);
  box-shadow: 0 16px 56px rgba(0, 0, 0, .7);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.gx-topbar__notif-head {
  padding: 12px 16px 0;
  background: #FFFFFF;
  flex-shrink: 0;
  border-bottom: 1px solid #E1E5EE;
}
.gx-topbar__notif-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.gx-topbar__notif-title-wrap {
  display: flex;
  align-items: center;
  gap: 7px;
}
.gx-topbar__notif-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 15px;
  font-weight: 700;
  color: #1A1A2E;
}
.gx-topbar__notif-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  background: #D4A946;
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 700;
  color: #0A0B1E;
  padding: 0 4px;
}
.gx-topbar__notif-head-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.gx-topbar__notif-link {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 11px;
  color: #D4A946;
  padding: 0;
  transition: color .15s;
}
.gx-topbar__notif-link:hover {
  color: #FFD700;
}
.gx-topbar__notif-close {
  width: 24px;
  height: 24px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 1px solid rgba(212, 169, 70, .25);
  cursor: pointer;
}
.gx-topbar__notif-close:hover {
  background: rgba(212, 169, 70, .1);
}
.gx-topbar__notif-tabs {
  display: flex;
  border-bottom: 1px solid #E1E5EE;
}
.gx-topbar__notif-tab {
  flex: 1;
  padding: 7px 0;
  border: none;
  cursor: pointer;
  background: transparent;
  font-size: 12px;
  color: #6A6A8A;
  position: relative;
  transition: color .15s;
}
.gx-topbar__notif-tab--on {
  color: #FFD700;
  font-weight: 600;
}
.gx-topbar__notif-tab-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #D4A946;
  position: absolute;
  top: 6px;
  right: 20%;
}
.gx-topbar__notif-tab-beam {
  position: absolute;
  bottom: 0;
  left: 15%;
  right: 15%;
  height: 2px;
  border-radius: 2px 2px 0 0;
  background: linear-gradient(90deg, #D4A946, #FFD700);
}
.gx-topbar__notif-list {
  overflow-y: auto;
  flex: 1;
  scrollbar-width: none;
}
.gx-topbar__notif-empty {
  padding: 48px 0;
  text-align: center;
}
.gx-topbar__notif-empty-icon {
  font-size: 32px;
  margin-bottom: 8px;
}
.gx-topbar__notif-empty-text {
  font-size: 13px;
  color: #6A6A8A;
}
.gx-topbar__notif-item {
  padding: 12px 16px;
  background: transparent;
  position: relative;
  transition: background .2s;
}
.gx-topbar__notif-item--unread {
  background: rgba(212, 169, 70, .04);
}
.gx-topbar__notif-item:hover {
  background: rgba(212, 169, 70, .07);
}
.gx-topbar__notif-dot {
  position: absolute;
  top: 14px;
  left: 6px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #D4A946;
}
.gx-topbar__notif-item-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 5px;
}
.gx-topbar__notif-tag {
  padding: 1px 7px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
  margin-top: 1px;
}
.gx-topbar__notif-item-title {
  font-size: 13px;
  font-weight: 600;
  color: #1A1A2E;
  line-height: 1.3;
  flex: 1;
}
.gx-topbar__notif-item-title--read {
  font-weight: 400;
  color: #9AA3B5;
}
.gx-topbar__notif-item-time {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  color: #A8B0C2;
  flex-shrink: 0;
  white-space: nowrap;
}
.gx-topbar__notif-source {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  color: #8A95B0;
  margin-bottom: 2px;
}
.gx-topbar__notif-content {
  font-size: 12px;
  color: #4A4A6A;
  line-height: 1.6;
  margin: 5px 0 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.gx-topbar__notif-content--read {
  color: #6A6A8A;
}
.gx-topbar__notif-actions {
  display: flex;
  gap: 7px;
}
.gx-topbar__notif-mini {
  height: 22px;
  padding: 0 9px;
  border-radius: 4px;
  cursor: pointer;
  background: rgba(100, 130, 200, .12);
  border: 1px solid rgba(212, 169, 70, .3);
  font-size: 10px;
  color: #D4A946;
  transition: all .13s;
}
.gx-topbar__notif-mini:hover {
  background: rgba(212, 169, 70, .25);
}
.gx-topbar__notif-mini--del {
  background: transparent;
  border: 1px solid #E1E5EE;
  color: #8A95B0;
}
.gx-topbar__notif-mini--del:hover {
  background: rgba(239, 68, 68, .15);
  color: #F87171;
  border-color: rgba(239, 68, 68, .3);
}
.gx-topbar__notif-foot {
  padding: 10px 16px;
  border-top: 1px solid #E1E5EE;
  background: #FFFFFF;
  text-align: center;
  flex-shrink: 0;
}
.gx-topbar__all {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(5, 10, 25, .6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gx-topbar__all .gx-topbar__notif-item-title {
  font-size: 14px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-topbar__all .gx-topbar__notif-item-title--read {
  font-weight: 400;
  color: #6A6A8A;
}
.gx-topbar__all .gx-topbar__notif-item-time {
  font-size: 11px;
  color: #8A95B0;
}
.gx-topbar__all .gx-topbar__notif-source {
  font-size: 11px;
  color: #6A6A8A;
}
.gx-topbar__all .gx-topbar__notif-content {
  font-size: 13px;
  color: #333;
  line-height: 1.7;
  -webkit-line-clamp: 3;
}
.gx-topbar__all .gx-topbar__notif-content--read {
  color: #6A6A8A;
}
.gx-topbar__all .gx-topbar__notif-tag {
  font-size: 11px;
}
.gx-topbar__all .gx-topbar__notif-mini {
  font-size: 11px;
  height: 24px;
}
.gx-topbar__all .gx-topbar__notif-item {
  padding: 14px 18px;
}
.gx-topbar__all-box {
  width: 100%;
  max-width: 640px;
  height: 82vh;
  border-radius: 14px;
  background: #FFFFFF;
  border: 1px solid rgba(212, 169, 70, .25);
  box-shadow: 0 24px 64px rgba(0, 0, 0, .5);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.gx-topbar__all-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid #E1E5EE;
  background: #F5F0E8;
  flex-shrink: 0;
}
.gx-topbar__all-title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gx-topbar__all-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 16px;
  font-weight: 700;
  color: #1A1A2E;
}
.gx-topbar__all-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.gx-topbar__all-tabs {
  display: flex;
  border-bottom: 1px solid #E1E5EE;
  background: #FFFFFF;
  flex-shrink: 0;
}
.gx-topbar__all-list {
  flex: 1;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(212, 169, 70, .45) #F4F6F8;
}
.gx-topbar__all-list::-webkit-scrollbar {
  width: 6px;
}
.gx-topbar__all-list::-webkit-scrollbar-track {
  background: #F4F6F8;
}
.gx-topbar__all-list::-webkit-scrollbar-thumb {
  background: rgba(212, 169, 70, .45);
  border-radius: 3px;
}
.gx-topbar__all-list::-webkit-scrollbar-thumb:hover {
  background: rgba(212, 169, 70, .7);
}
@media (max-width: 640px) {
  .gx-topbar__all-box {
    height: 92vh;
  }
}
.gx-topbar__notif-foot .gx-topbar__notif-link {
  font-weight: 500;
}
.gx-topbar__notif-foot .gx-topbar__notif-link:hover {
  text-decoration: underline;
}
.gx-topbar__bell:hover {
  background: rgba(212, 169, 70, .22);
  border-color: rgba(212, 169, 70, .5);
}
.gx-topbar__badge {
  position: absolute;
  top: 3px;
  right: 3px;
  min-width: 14px;
  height: 14px;
  border-radius: 7px;
  background: #FFD700;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'JetBrains Mono', monospace;
  font-size: 8px;
  font-weight: 700;
  color: #C8443C;
  padding: 0 3px;
  animation: gx-bellPulse 2s infinite;
}
@keyframes gx-bellPulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(212, 169, 70, .7); }
  65% { box-shadow: 0 0 0 7px rgba(212, 169, 70, 0); }
}
.gx-topbar__user {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 5px 14px 5px 5px;
  border-radius: 22px;
  background: rgba(255, 255, 255, .15);
  border: 1px solid rgba(255, 255, 255, .2);
  cursor: pointer;
  transition: all .3s cubic-bezier(.4, 0, .2, 1);
}
.gx-topbar__user:hover {
  background: rgba(255, 255, 255, .24);
}
.gx-topbar__avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #D4A946, #00D4FF);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Noto Serif SC', serif;
  font-size: 12px;
  font-weight: 700;
  color: #1A1A2E;
  flex-shrink: 0;
  overflow: hidden;
}
.gx-topbar__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.gx-topbar__user-text {
  display: flex;
  flex-direction: column;
}
.gx-topbar__user-phone {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  line-height: 1.2;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-topbar__user-level {
  font-size: 10px;
  color: #FFD700;
  line-height: 1.2;
}
.gx-topbar__logout {
  height: 30px;
  padding: 0 12px;
  border-radius: 7px;
  border: 1px solid rgba(255, 255, 255, .22);
  background: transparent;
  cursor: pointer;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 12px;
  color: rgba(255, 255, 255, .7);
  transition: all .3s cubic-bezier(.4, 0, .2, 1);
}
.gx-topbar__logout:hover {
  color: #fff;
}
</style>
<style scoped>
.fixed_menu{width: 32px;height: auto;position: fixed;right: 6px;top: 50%;transform: translateY(-50%);z-index: 99;transition: all .5s;}
.fixed_menu .backtop{width: 32px;height: 34px;background: var(--gx-red);margin-top: 4px;display: flex;justify-content: center;align-items: center;cursor: pointer;position: initial;border-radius: initial;box-shadow: initial;}
.fixed_menu .backtop .icon-top{font-size: 18px;color: #fff;}
.fixed_menu .inner-wrap {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1px;
}
.fixed_menu .inner-wrap i {
  color: #fff;
  font-size: 8px;
}
.fixed_menu .inner-wrap span {
  color: #fff;
  font-size: 8px;
  line-height: 1;
}
</style>
